import React from "react";
import { PaqueteOfrecido } from "./PaqueteOfrecido"; 
import Carousel from "react-multi-carousel";
import { ReactImageCarouselViewer } from "react-image-carousel-viewer";
import img1 from "../../assets/paquete1.jpg";
import img2 from "../../assets/paquete2.jpg";
import img3 from "../../assets/paquete3.jpg";
import img4 from "../../assets/paquete4.jpg";

const PaqueteConCarousel = ({
    paquete,
    setPaquete,
    setModalAnadirServicio,
    setModalAnadirPaqueteServicioShareCare,
    comprobaciones,
    responsive
}) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [index, setIndex] = React.useState(0);

    const imagenes = paquete.nombrePaquete.includes("Tablet")
        ? [
            { url: img3 },
            { url: img2 },
            { url: img4 }
        ]
        : [
            { url: img1 },
            { url: img2 },
            { url: img3 }
        ];

    return (
        <div>
            <PaqueteOfrecido
                paquete={paquete}
                setPaquete={setPaquete}
                setModalAnadirServicio={setModalAnadirServicio}
                setModalAnadirPaqueteServicioShareCare={setModalAnadirPaqueteServicioShareCare}
                comprobaciones={comprobaciones}
            />

            {imagenes.length > 0 ? (
                <div className='carrousel-imagenes-perfil-empresa'>
                    <Carousel
                        swipeable={false}
                        draggable={true}
                        centerMode={false}
                        focusOnSelect={true}
                        autoPlay={true}
                        autoPlaySpeed={3000}
                        transitionDuration={800}
                        responsive={responsive}
                        ssr={true}
                        infinite={true}
                        keyBoardControl={true}
                        containerClass='carousel-container'
                        deviceType={responsive.desktop}
                        removeArrowOnDeviceType={['tablet', 'mobile']}
                        dotListClass='custom-dot-list-style'
                        itemClass='carousel-item-padding-40-px'
                    >
                        {imagenes.map((foto, i) => (
                            <div className='imagen-carrousel-perfil-agencia' key={i}>
                                <img
                                    src={foto.url}
                                    onClick={() => {
                                        setIndex(i);
                                        setIsOpen(true);
                                    }}
                                />
                            </div>
                        ))}
                    </Carousel>

                    <ReactImageCarouselViewer
                        open={isOpen}
                        onClose={() => setIsOpen(false)}
                        images={imagenes.map(img => img.url)}
                        startIndex={index}
                        disableScroll={true}
                        containerClass='carousel-viewer-container'
                    />
                </div>
            ) : (
                <p>Este paquete no tiene imágenes.</p>
            )}
        </div>
    );
};

export default PaqueteConCarousel;